import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RecurringTransfer, RecurringTransferPayload, RecurringTransfersResponse } from '../models/recurring-transfers.model';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class RecurringTransfersService {
  private readonly resourceUrl = '/recurring-transfers';

  constructor(private apiService: ApiService) {}

  getActiveDistributionCount(): Observable<number> {
    const params = new HttpParams().set('status', 'ACTIVE');
    return this.apiService.get(`${this.resourceUrl}/distribution/count`, params) as Observable<number>;
  }

  getRecurringSchedules(
    pageNumber: number,
    resultsPerPage: number,
    isGrant: boolean,
    senderCseg5: string
  ): Observable<RecurringTransfersResponse> {
    const params = new HttpParams()
      .set('type', isGrant ? 'TRANSFER' : 'GRANT')
      .set('page', pageNumber.toString())
      .set('pageSize', resultsPerPage.toString())
      .set('senderCseg5', senderCseg5);
    return this.apiService.get(this.resourceUrl, params) as Observable<RecurringTransfersResponse>;
  }

  updateTransaction(payload: RecurringTransferPayload): Observable<RecurringTransfer> {
    const { id, ...body } = payload;
    return this.apiService.post(`${this.resourceUrl}/${id}`, body) as Observable<RecurringTransfer>;
  }

  deleteTransaction(id: string): Observable<void> {
    return this.apiService.delete(`${this.resourceUrl}/${id}`) as unknown as Observable<void>;
  }
}
